const blockers = [];
export const addBlocker = (blocker) => {
    blockers.push(blocker);
    return () => {
        const index = blockers.indexOf(blocker);
        if (index !== -1)
            blockers.splice(index, 1);
    };
};
export const currentBlocker = () => { var _a; return (_a = blockers[blockers.length - 1]) !== null && _a !== void 0 ? _a : null; };
